module.exports = __webpack_public_path__ + "static/media/fisheye-sens-2.631c9fa1.png";